import React, { useEffect } from "react";
import { LoggerFactory } from "lego-gui-lib";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import queryString, { ParsedQuery } from "query-string";
import { Loader } from "./loadingComponent";

const log = LoggerFactory.create("LogoutRedirectView");

export const LogoutRedirectView = inject("auth")(
  observer((props: any) => {
    const auth = props.auth;
    const queryParams: ParsedQuery = queryString.parse(window.location.search);
    const redirectState = auth.getRedirectState();

    log.debug("Successful logout response queryParams", queryParams);
    log.debug("Successful logout response redirectState", redirectState);

    useEffect(() => {
      auth.redirectToSSO();
    }, [auth]);

    return <Loader />;
  })
);

// export const LoginFailedRedirectView = inject("i18n")(
//   observer((props: any) => {
//     const i18n = props.i18n;
//     const queryParams: ParsedQuery = queryString.parse(window.location.search);
//
//     log.error("Failed login response queryParams", queryParams);
//
//     return (
//       <Typography
//         variant={"h3"}
//         color={"inherit"}
//         style={{ padding: "2em", textAlign: "center" }}
//       >
//         {i18n.t("hns:auth:loginFailed")}
//       </Typography>
//     );
//   })
// );
